// extracted by mini-css-extract-plugin
export default {"wrapper":"BrokenBanks_wrapper__qsYzr"};